import * as checkboxes from './checkboxes';
import * as select2 from './select2';
import * as fancybox from './fancybox';
import * as siteAnimation from './site-animation';
import { app } from "./stimp/app";

window.$ = window.jQuery;

jQuery( $ => {
  checkboxes.initApplyAll();
  checkboxes.initApplyReset();
  select2.init();
  fancybox.init();
  app.init();
  siteAnimation.init();
  console.log("Yep, it works!!!");
})
